import gsap, { Expo } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const FADE_UP_DURATION_S = 0.75;
const FADE_IN_DURATION_S = 1;

/**
 * If the element has an adjacent animating element, use the first one as the
 * trigger.
 */
const getTriggerElement = (element: Element) =>
  element.parentElement?.querySelector(".js-fade-up, .js-fade-in") || element;

gsap.utils.toArray<HTMLElement>(".js-fade-up").forEach((element) => {
  // Smaller YPercentage animation if the element height is tall.
  const yPercent = parseInt(
    element.dataset.yPercent ??
      (window.innerHeight / 3 < element.clientHeight / 2 ? "25" : "50")
  );

  gsap.fromTo(
    element,
    {
      autoAlpha: 0,
      yPercent,
      ease: Expo.easeInOut,
    },
    {
      scrollTrigger: {
        trigger: getTriggerElement(element),
        once: true,
      },
      duration: FADE_UP_DURATION_S,
      autoAlpha: 1,
      yPercent: 0,
    }
  );
});

gsap.utils.toArray<HTMLElement>(".js-fade-in").forEach((element) => {
  gsap.fromTo(
    element,
    {
      autoAlpha: 0,
      ease: Expo.easeInOut,
    },
    {
      scrollTrigger: {
        trigger: getTriggerElement(element),
        once: true,
      },
      duration: FADE_IN_DURATION_S,
      autoAlpha: 1,
      yPercent: 0,
    }
  );
});

window.addEventListener("load", () => ScrollTrigger.refresh());
document.addEventListener("lazyloaded", () => ScrollTrigger.refresh());
